/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/mulberrys/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 71);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(72);


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* global google */
$(
	function() {
		function initialize() {

			var map = new google.maps.Map(
				document.getElementById( "current_location" ),
				{
					center: {lat: 44.968032, lng: -93.259883},
					zoom: 6,
				}
			);

			var markers = new Array();
			/**var infowindow = new google.maps.InfoWindow({
				maxWidth: 160,
			});**/

			// eslint-disable-next-line no-undef
			var stores_injected = stores;

			for (var i = 0; i < stores_injected.length; i++) {
				var lat = stores_injected[i]['location']['google_maps']['lat'];
				var lng = stores_injected[i]['location']['google_maps']['lng'];

				if ( ! lat) {
					continue;
				}

				var title = stores_injected[i]['location']['title'];
				//var address = stores_injected[i]['location']['address'];

				var marker = new google.maps.Marker(
					{
						position: new google.maps.LatLng( lat, lng ),
						title: title,
						map: map,
						//icon: icons[iconCounter]
					}
				);
				markers.push( marker );
			}

			// Autocenter with given markers
			//  Create a new viewpoint bound
			var bounds = new google.maps.LatLngBounds();
			//  Go through each...
			for (var j = 0; j < markers.length; j++) {
				bounds.extend( markers[j].position );
			}
			//  Fit these bounds to the map
			map.setCenter( bounds.getCenter() );
			map.setZoom( 10 );
		}
		initialize();
	}
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

/******/ });


// WEBPACK FOOTER //
// scripts/page-map_91b0b140.js